import * as defaultImport from "lodash/noop";
export * from "lodash/noop";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
